import { render, staticRenderFns } from "./final_answer_detail.vue?vue&type=template&id=2642a159&scoped=true"
import script from "./final_answer_detail.vue?vue&type=script&lang=js"
export * from "./final_answer_detail.vue?vue&type=script&lang=js"
import style0 from "./final_answer_detail.vue?vue&type=style&index=0&id=2642a159&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2642a159",
  null
  
)

export default component.exports